import React from 'react';
import PurchaseOrderProgressPresenter from './PurchaseOrderProgressPresenter';

import { colorSet } from '@components/Provider';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';

import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSelector } from '@store';
import { CommomRfqBubbleProps } from '@components/Chat/types';
import useDocuments from '@hooks/useDocuments';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: 16
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all'
    },
    footer: {
      padding: 16
    }
  };
});

const QuotationAgreementBubble = ({ chatMessage }: CommomRfqBubbleProps) => {
  const classes = useStyles();
  const history = useHistory();

  const { onUpdateDocumentsCurrentId } = useDocuments();
  const menuStatus = useSelector((state) => state.chat.menuStatus);

  const onClick = () => {
    if (chatMessage?.rfq?.purchaseOrderId) {
      onUpdateDocumentsCurrentId({
        selectedPurchaseOrderId: chatMessage?.rfq?.purchaseOrderId ?? undefined
      });
    }

    history.push(history.location.pathname + '?menu=purchaseorder');
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          발주서
        </CustomizedTypography>
      </div>
      <PurchaseOrderProgressPresenter activeStep={0} />
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
          >
            발주서 발행
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className={classes.wordBreak}>
            파트너와 추가 조건(검수, 납품, 결제 등) 협의 후 발주서를 작성해
            주세요.
            <br />
            <br />
            협의된 내용은 빠짐없이 발주서에 반영해 주세요. 혹시 모를 분쟁 발생시
            남겨진 문서가 분쟁 조정의 기반이 됩니다.
          </CustomizedTypography>
        </div>
      </div>
      <div className={classes.footer}>
        <CustomizedButton
          disabled={menuStatus?.purchaseOrder}
          variant="contained"
          color="primary"
          size="small"
          fullWidth
          onClick={onClick}
        >
          발주서 보기
        </CustomizedButton>
      </div>
    </div>
  );
};

export default QuotationAgreementBubble;
